export default "__VITE_ASSET__e1aeba29__"